import React from 'react';
import {
  EmptyState,
  EmptyStateBody,
  EmptyStateHeader,
  EmptyStateIcon,
} from '@patternfly/react-core';
import ErrorIcon from '@patternfly/react-icons/dist/esm/icons/error-circle-o-icon';
import { useTranslation } from 'react-i18next';

/**
 * Shown when the user navigates to a Skills Path page but the skills_paths_enabled
 * feature flag is not enabled for them (access forbidden).
 */
const SkillsPathForbiddenView = () => {
  const { t } = useTranslation();
  return (
    <div className="container-grid-responsive">
      <EmptyState>
        <EmptyStateHeader
          titleText={t('Access denied')}
          headingLevel="h4"
          icon={
            <EmptyStateIcon
              icon={ErrorIcon}
              color="var(--pf-v5-global--danger-color--100)"
            />
          }
        />
        <EmptyStateBody>
          {t(
            'You do not have access to Skills Paths. If you believe this is an error, contact support.',
          )}
        </EmptyStateBody>
      </EmptyState>
    </div>
  );
};

export default SkillsPathForbiddenView;
